import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import s from './pages.module.scss';
import { useAppState, useTranslation } from '../appState';

const PrivacyPolicyPage: React.FC = () => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const lang = useTranslation('pages');
  const { privacyPolicy } = useAppState();
  return (
    <main className={s.wrapper}>
      <ReactMarkdown>
        {privacyPolicy}
      </ReactMarkdown>
      <a className={s.homeLink} onClick={goBack}>{lang.homepageBtn}</a>
    </main>
  );
};

export default PrivacyPolicyPage;
